import { Grid, Paper } from "@material-ui/core";
import { MasterButton, SearchInput } from "App/Component/ui";
import Title from "App/Component/ui/title/Title";
import { isNull } from "App/utils/helpers";
import { split } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { LokasiCtx } from "../context/context";
import {
  getLokasi,
  STATE_ALAMAT,
  STATE_INFO,
  STATE_JADWAL,
  STATE_KONTAK,
  STYLE_MASTER_SATU_SEHAT_LOKASI,
} from "./helpers";
import { useReloadTable } from "./hooks";
import LokasiPreview from "./LokasiPreview";
import LokasiTable from "./LokasiTable";

export default function LokasiWrapper() {
  const [open, setOpen] = useState(false);
  const { state } = useContext(LokasiCtx);
  const rows = state.lokasi.body;
  const totalData = state.lokasi.count;

  const classes = STYLE_MASTER_SATU_SEHAT_LOKASI();

  const [formDataInfo, setFormDataInfo] = useState(STATE_INFO);
  const [formDataJadwal, setFormDataJadwal] = useState(STATE_JADWAL);
  const [formDataAlamat, setFormDataAlamat] = useState(STATE_ALAMAT);
  const [formDataKontak, setFormDataKontak] = useState(STATE_KONTAK);
  const [children, setChildren] = useState([]);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [infoChildren, setInfoChildren] = useState("");

  const {
    resetPagination,
    setNewData,
    pagination,
    onPrevious,
    onNext,
    handleClickPageNumber,
    handleChangeLimit,
    loading,
    handleChange,
    formFilter,
    setFormFilter,
  } = useReloadTable();

  useEffect(() => {
    setNewData();
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open);
  };

  const handleOpenLokasi = async () => {
    setFormDataInfo({
      ...STATE_INFO,
      id_location:
        children.length === 0 ? "" : children[children.length - 1].id_location,
      isUpdate: false,
      id: children.length === 0 ? "" : children[children.length - 1].id,
    });
    setFormDataJadwal(STATE_JADWAL);
    setFormDataAlamat(STATE_ALAMAT);
    setFormDataKontak(STATE_KONTAK);
    setOpen((prev) => !prev);
  };

  const handleEditLokasi = async (row) => {
    try {
      const isAddress = Object.keys(row.address).length === 0;
      setFormDataInfo({
        id: row.id,
        id_location: row.id_location,
        parent_id_location: row.parent_id_location,
        kode: row.kode,
        poliklinikValue: row?.id_poliklinik??"",
        poliklinikLabel: row.nama_poli??"Pilih Poliklinik",
        layananValue: row?.id_layanan??"",
        layananLabel: row?.nama_layanan??"Pilih Layanan",
        jenisLokasiValue: isNull(row.jenis_lokasi) ? 'P' : row.jenis_lokasi,
        jenisLokasiLabel: isNull(row.jenis_lokasi) || row.jenis_lokasi === 'P' ? 'Poliklinik' : 'Layanan',
        name: row.name,
        description: row.description,
        status: row.status,
        type: row.type,
        mode: row.mode,
        operationalStatus: row.operationalStatus,
        physicalTypeValue: isNull(row?.physicalType?.coding?.[0]?.code)
          ? ""
          : row.physicalType.coding[0].code,
        physicalTypeLabel: isNull(row?.physicalType?.coding?.[0]?.display)
          ? ""
          : row.physicalType.coding[0].display,
        isUpdate: true,
      });
      setFormDataJadwal({
        hari_awal:
          row.hoursOfOperation.length === 0
            ? ""
            : row.hoursOfOperation?.[0].hari_awal,
        hari_akhir:
          row.hoursOfOperation.length === 0
            ? ""
            : row.hoursOfOperation?.[0].hari_akhir,
        jam_awal:
          row.hoursOfOperation.length === 0
            ? ""
            : row.hoursOfOperation?.[0].jam_awal,
        jam_akhir:
          row.hoursOfOperation.length === 0
            ? ""
            : row.hoursOfOperation?.[0].jam_akhir,
        availabilityExecptions:
          row.hoursOfOperation.length === 0 ? [] : row.availabilityExecptions,
        available: row.hoursOfOperation.length === 0 ? false : true,
      });
      setFormDataAlamat({
        available: isAddress ? false : true,
        use: isAddress ? "" : row.address.use,
        type: isAddress ? "" : row.address.type,
        line: isAddress ? [] : row.address.line?.[0],
        postalCode: isAddress ? "" : row.address.postalCode,
        country: isAddress ? "" : row.address.country,
        url: isAddress ? "" : row?.address?.extension?.[0]?.extension?.[0]?.url,
        province: isAddress
          ? ""
          : row?.address?.extension?.[0]?.extension?.[0]?.valueCode,
        province_name: isAddress
          ? ""
          : row?.address?.extension?.[0]?.extension?.[0]?.url,
        city: isAddress ? "" : row?.address?.extension?.[0]?.extension?.[1]?.valueCode,
        city_name: isAddress ? "" : row?.address?.extension?.[0]?.extension?.[1]?.url,
        district: isAddress
          ? ""
          : row?.address?.extension?.[0]?.extension?.[2]?.valueCode,
        district_name: isAddress
          ? ""
          : row?.address?.extension?.[0]?.extension?.[2]?.url,
        sub_district: isAddress
          ? ""
          : row?.address?.extension?.[0]?.extension?.[3]?.valueCode,
        sub_district_name: isAddress
          ? ""
          : row?.address?.extension?.[0]?.extension?.[3]?.url,
      });
      setFormDataKontak({
        phone: row?.telecom?.length === 0 ? null : row?.telecom?.[0]?.value,
        email: row?.telecom?.length === 0 ? null : row?.telecom?.[1]?.value,
        url: row?.telecom?.length === 0 ? null : row?.telecom?.[2]?.value,
      });
      setOpen((prev) => !prev);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBackLokasi = async () => {
    if (children.length === 1) {
      setChildren([]);
      setNewData(1, 10, { parent_id_location: "", id_location: "", name: "" });

      setInfoChildren("");
    } else {
      const id = children[children.length - 1].id_location;
      const filterID = children.filter((x) => x.id_location !== id);
      await setNewData(1, 10, {
        parent_id_location: filterID[filterID.length - 1].id_location,
        name: "",
      });
      setChildren(filterID);

      const forPosisi = infoChildren.split("/");
      const filterPosisi = forPosisi[forPosisi.length - 1];
      const lastPosition = forPosisi.filter((x) => x !== filterPosisi);
      setInfoChildren(lastPosition.join("/"));
    }
  };

  const handleChildren = async (row) => {
    await setNewData(1, 10, {
      parent_id_location: row.id_location,
      name: "",
    });

    setChildren([
      ...children,
      isNull(row.parent_id_location)
        ? {
            id_location: row.id_location,
            id: row.id,
            parent_id_location: "",
          }
        : {
            id_location: row.id_location,
            id: row.id,
            parent_id_location: row.parent_id_location,
          },
    ]);

    if (isNull(row.parent_id_location)) {
      setInfoChildren(row.kode);
    } else {
      setInfoChildren(`${infoChildren}/${row.kode}`);
    }
  };

  const handleSearch = async (row) => {
    setNewData(1, 10, {
      name: row,
      parent_id_location: "",
    });
  };

  return (
    <>
      <Title title='Satu Sehat - Lokasi' />

      <Paper className={classes.paper}>
        <div className='mb-1'>
          <Grid
            container
            direction='row'
            spacing={1}
            alignItems='center'
            justifyContent='space-between'>
            <p className='fw-200 fs-16'>
              {isNull(infoChildren) ? "" : infoChildren}
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
              }}>
              <SearchInput
                withIcon={true}
                onchange={(e) => handleSearch(e.target.value)}
              />
              <MasterButton
                type='submit'
                name={"Tambah Lokasi"}
                size='md'
                onClick={() => handleOpenLokasi()}
              />
              {children.length === 0 ? (
                <></>
              ) : (
                <MasterButton
                  type='submit'
                  name={"Kembali"}
                  size='md'
                  color='warning'
                  onClick={() => handleBackLokasi()}
                />
              )}
            </div>
          </Grid>
        </div>

        <LokasiPreview
          open={open}
          setOpen={setOpen}
          toggleDrawer={toggleDrawer}
          formDataInfo={formDataInfo}
          setFormDataInfo={setFormDataInfo}
          formDataJadwal={formDataJadwal}
          setFormDataJadwal={setFormDataJadwal}
          formDataAlamat={formDataAlamat}
          setFormDataAlamat={setFormDataAlamat}
          formDataKontak={formDataKontak}
          setFormDataKontak={setFormDataKontak}
          latitude={latitude}
          setLatitude={setLatitude}
          longitude={longitude}
          setLongitude={setLongitude}
          setNewData={setNewData}
        />

        <LokasiTable
          rows={rows}
          handleClickEdit={handleEditLokasi}
          handleChildren={handleChildren}
          totalData={totalData}
          resetPagination={resetPagination}
          setNewData={setNewData}
          pagination={pagination}
          onPrevious={onPrevious}
          onNext={onNext}
          handleClickPageNumber={handleClickPageNumber}
          handleChangeLimit={handleChangeLimit}
          loading={loading}
          handleChange={handleChange}
          formFilter={formFilter}
          setFormFilter={setFormFilter}
          children={children}
        />
      </Paper>
    </>
  );
}
